import { useState, useCallback } from "react";

/**
 * useCopy — clipboard copy with timed "copied" feedback state.
 *
 * @param {string} text  — text to copy
 * @param {number} ms    — how long the "copied" state stays true (default 2000ms)
 * @returns {{ copied: boolean, copy: () => void }}
 */
export function useCopy(text, ms = 2000) {
  const [copied, setCopied] = useState(false);
  const copy = useCallback(() => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), ms);
    });
  }, [text, ms]);
  return { copied, copy };
}
